import { render, staticRenderFns } from "./booklibrary.vue?vue&type=template&id=4a53fb0c&scoped=true&"
import script from "./booklibrary.vue?vue&type=script&lang=js&"
export * from "./booklibrary.vue?vue&type=script&lang=js&"
import style0 from "./booklibrary.vue?vue&type=style&index=0&id=4a53fb0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a53fb0c",
  null
  
)

export default component.exports